const contracts = require('@bazarion/protocol/contracts.json')


module.exports = contracts
